/* eslint-disable no-param-reassign */
import axios from 'axios';

const api = axios.create({ baseURL: process.env.VUE_APP_API_HOST });

api.interceptors.request.use((config) => {
  if (!config.headers.Authorization || config.headers.Authorization === 'Bearer null' || config.headers.Authorization === 'Bearer undefined') {
    try {
      const stored = sessionStorage.getItem('auth:token') || sessionStorage.getItem('auth:tokenlocal');
      if (stored) {
        const parsed = JSON.parse(stored);
        const token = parsed?.token || parsed;
        if (token && typeof token === 'string') {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
    } catch (e) {
      // Ignora erro de parse
    }
  }
  return config;
});

export default api;

export function apiSetToken(token) {
  api.defaults.headers.Authorization = token ? `Bearer ${token}` : null;
}

export function setupApiOnResponseError(responseInterceptor) {
  api.interceptors.response.use(null, responseInterceptor);
}

export async function setupBaseURL() {
  if (process.env.NODE_ENV !== 'production' || !navigator.onLine) return;
  const { data } = await axios.get('/api-base-url');
  api.defaults.baseURL = data;
}
